// Brand blog posts, keyed by brand.slug. Each post has bilingual title + body
// paragraphs (array). Optional video or image.

export const BRAND_BLOGS = {
  zed: [
    {
      id: "euphoria-run-club",
      video:
        "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/c4140506b62c6933_IMG_7599.MOV",
      date: "2026-11",
      title: {
        ar: "٣ كيلومترات.. مجتمع واحد",
        en: "3 Kilometers, One Community",
      },
      excerpt: {
        ar: "استضافنا نادي Euphoria Run Club بعد جولتهن لمسافة ٣ كيلومترات على كورنيش جدة.",
        en: "We welcomed Euphoria Run Club to ZED after their 3-kilometer run along the Jeddah Corniche.",
      },
      body: {
        ar: [
          "في ZED، نسعد دائمًا بأن نكون جزءًا من اللحظات التي تجمع أهل جدة.",
          "مؤخرًا، استضفنا نادي Euphoria Run Club، وهو مجتمع جري مخصص للنساء، بعد جولتهن لمسافة ٣ كيلومترات على الكورنيش. ما بدأ كجولة جري خفيفة، تحوّل إلى وقت ممتع مليء بالحركة، والتواصل، والطاقة الإيجابية؛ تمامًا كنوع التجارب اليومية التي نحب أن نكون جزءًا منها.",
          "يعكس الإقبال المتزايد على مجتمعات الجري النسائية في المملكة تحولًا نحو نمط حياة أكثر حيوية وتواصلًا. ومع تركيز رؤية السعودية 2030 على الرياضة، والصحة، وجودة الحياة، أصبحت المرأة تصنع مساحات جديدة للحركة والالتقاء، وتجعل الرياضة جزءًا ممتعًا من يومها.",
          "وهذا ما يجعل مجتمعات مثل Euphoria مميزة؛ فهي تشجع النساء على الحركة، وتمنحهن فرصة للالتقاء ومشاركة وقت ممتع معًا. ومشاركتنا في مثل هذه المبادرات تعكس اهتمامنا بالمجتمعات التي تضيف حيوية إلى الحياة اليومية.",
          "في ZED، نؤمن أن ما نقدمه يتجاوز ما هو على الطاولة؛ فهناك دائمًا مساحة لطاقة جديدة، وأفكار مختلفة، وطرق مبتكرة تجمع الناس.",
          "٣ كيلومترات. مجتمع واحد. ولحظات تكملها ZED.",
        ],
        en: [
          "At ZED, we're always happy to be part of the moments that bring the people of Jeddah together.",
          "Recently, we welcomed Euphoria Run Club, a women's running community, to ZED after their 3-kilometer run along the Corniche. What started as a light run turned into an evening filled with movement, connection and positive energy — exactly the kind of everyday experiences we love being part of.",
          "The growing popularity of women's running communities across Saudi Arabia reflects a shift toward more active and connected lifestyles. As Vision 2030 continues to place a strong focus on sports, health and quality of life, women are creating new spaces to move, connect and make fitness an enjoyable part of their everyday lives.",
          "That's what makes communities like Euphoria special. They encourage women to stay active while creating opportunities to meet, connect and simply enjoy time together. Being part of initiatives like these reflects our belief in supporting communities that bring more energy and vitality into everyday life.",
          "At ZED, we believe what we offer goes beyond what's on the table. There's always room for fresh energy, new ideas and different ways of bringing people together.",
          "3 kilometers. One community. And moments made better with ZED.",
        ],
      },
    },
  ],
};

export const BLOGS_LABEL = {
  kicker: { ar: "المدوّنة", en: "The Journal" },
  title: { ar: "سوالف زد", en: "ZED Diaries" },
  readMore: { ar: "اقرأ المزيد", en: "Read more" },
  readLess: { ar: "طيّ", en: "Show less" },
};
